<template>
  <div class="submitRefund">
    <van-sticky>
      <van-nav-bar
        :style="{ 'paddingTop':statusBarHeight,'backgroundColor': '#FFFFFF' }"
        title="申请退款"
        left-arrow
        @click-left="handleBack('back')"
      />
    </van-sticky>

    <main class="main">
      <div class="commodity">
        <h3>退款商品</h3>
        <div class="con">
          <div class="cover">
            <van-image fit="contain" :src="goodsDetails.picUrl" />
          </div>
          <div class="synopsis">
            <h4>{{goodsDetails.name}}</h4>
            <div class="price">¥ {{goodsDetails.salePrice}}</div>
            <div class="quantity">x{{goodsDetails.saleCount?goodsDetails.saleCount:1}}</div>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>退款信息</h3>
        <div class="money">
          退款金额：<span class="num">¥ {{goodsDetails.realPay}}</span>
        </div>
        <div class="reason">
          <div class="label"><span class="asterisk">*</span>退款原因</div>
          <div class="option" @click="openPicker">
            <span class="con" v-if="className">{{className}}</span>
            <span class="tip" v-else>请选择</span>
            <img src="../asset/images/right.png" alt="">
          </div>
        </div>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            title="退款原因"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <div class="explain">
          <div class="label">退款说明</div>
          <div class="text">
            <van-field
              v-model="explainText"
              rows="3"
              autosize
              type="textarea"
              maxlength="30"
              placeholder="补充描述退款说明"
              show-word-limit
            />
          </div>
        </div>
        <div class="uploading">
          <div class="label">上传图片<span>(限3张)</span></div>
          <div class="imgBox">
            <van-uploader
              :multiple="false"
              :max-count="3"
              accept="image/*"
              v-model="fileList"
              :before-read="beforeRead"
              :after-read="afterRead">
              <!-- <div v-if="$isapp" class="van-uploader__upload" @click.stop="handleClick" style="z-index:98;">
                <i class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
              </div> -->
            </van-uploader>
          </div>
        </div>
      </div>
    </main>

    <footer class="footer" style="z-index:99;">
      <div class="button" @click="onSettledClick">提交</div>
      <p class="tips" :style="{ paddingBottom: bottomSafeHeight }"></p>
    </footer>

  </div>
</template>

<script>
export default {
  name: "submitRefund",
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      orderId: this.$route.query.orderId,
      orderNo: this.$route.query.orderNo,
      source: this.$route.query.source,
      explainText: '',
      className: '',
      classId: null,
      columns: [],
      columns0: [
        { text: '多拍/拍错/不想要', value: 1 },
        { text: '缺货', value: 2 }
      ],
      columns1: [
        { text: '缺少件', value: 5 },
        { text: '发错货', value: 6 },
        { text: '质量问题', value: 7 },
        { text: '商品与描述不符', value: 8 },
        { text: '商品损坏', value: 9 },
        { text: '其它原因', value: 10 }
      ],
      showPicker: false,
      fileList: [],
			uploadLoading: false,
      goodsDetails: {},
      statusBarHeight: 0,
      bottomSafeHeight: 0
    };
  },
  mounted() {
    this.setCompatible();
    this.combinationGoodsDetail();
  },
  methods: {
    handleClick() {
      console.log('selectPhotos')
			this.$WDJSBridge
				.selectPhotos(JSON.stringify({ maxCount: 1 }))
				.then((res) => {
            console.log('图片链接-----------', res)
            this.fileList.push({url: res.content[0]})
            console.log('fileList--------',this.fileList)
            this.uploadLoading = false;
				})
				.catch((err) => {})
		},
    setCompatible() {
      if(localStorage.getItem('type') == 'iOS') {
        this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
        this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
      }
    },
    combinationGoodsDetail() {
      // this.$api.activities
      //   .combinationGoodsDetail({ params })
      //   .then((res) => {
      //     if (res.success) {
      //       this.goodsDetails = res.data;
      //     }
      //   });
      // if(this.$route.query.url=='combinedOrderDetail'){
      //   const params = {
      //     id: this.id
      //   }
      //   this.$api.activities
      //     .combinationGoodsDetail({ params })
      //     .then((res) => {
      //       if (res.success) {
      //         this.goodsDetails = res.data;
      //       }
      //   });
      // }else if(this.$route.query.url=='orderDetail'){
        const data = {
          orderNo: this.orderNo,
        }
        this.$api.applyRefund
          .getEntityGoodOrderDetail(data)
          .then((res) => {
            if (res.success) {
              this.goodsDetails = res.data.goodsList[0];
              this.goodsDetails.realPay = res.data.realPay;
            }
        });
      // }
    },
    openPicker() {
      if (this.type == 1) {
        this.columns = this.columns1;
      } else {
        this.columns = this.columns0;
      }
      this.showPicker = true;
    },
    onConfirm(value) {
      this.className = value.text;
      this.classId = value.value;
      this.showPicker = false;
    },
    beforeRead(file) {
      this.uploadLoading = true;
			if (file.type.indexOf('image') === -1) {
				this.$notify({ duration: 2000, type: 'danger', message: '请上传正确格式的图片' })
				this.uploadLoading = false;
				return false
			}
			return true
    },
    afterRead(file) {
      // file.status = 'uploading';
      // file.message = '上传中...';
			// 此时可以自行将文件上传至服务器
			let formData = new FormData()
			formData.append('file', file.file)
			this.$api.applyRefund
				.upload(formData)
				.then(async (res) => {
					if (res.code == 0) {
            this.fileList[this.fileList.length-1] = {url: res.data}
						this.uploadLoading = false;
            file.status = '';
            file.message = '';
					}
				})
				.catch((err) => {
          file.status = 'failed';
          file.message = '上传失败';
					this.uploadLoading = false;
				})
    },
    onSettledClick () {
      if (!this.classId) {
        this.$toast('请选择退款原因');
        return
      }
      if (this.uploadLoading) {
        this.$toast('图片正在上传');
        return
      }
      var data = {
        applicationType: this.type,
        image: this.fileList,
        money: this.goodsDetails.realPay,
        orderId: this.orderId,
        orderNo: this.orderNo,
        orderType: this.$route.query.url=='combinedOrderDetail'?2:1,
        refundCause: this.classId,
        remark:this.explainText
      }
      this.$api.applyRefund.refundSave(data).then((res) => {
				if (res.data) {
          this.$toast('提交成功，等待商家处理。')
          this.handleBack();
				}
			})
    },
    handleBack(type) {
      this.$router.go(-1)
      // if (type === 'back') {
      //   if (this.source == 'shippedRefund') {
      //     this.$router.go(-1)
      //   } else {
      //     this.$router.push({
      //       name: this.$route.query.url,
      //       params: {
      //         type: this.$route.query.url=='combinedOrderDetail'?5:this.$route.query.url=='orderDetail'?3:'',
      //         orderNo: this.orderNo,
      //       }
      //     })
      //   }
      // } else {
      //   this.$router.push({
      //     name: this.$route.query.url,
      //     params: {
      //       type: this.$route.query.url=='combinedOrderDetail'?5:this.$route.query.url=='orderDetail'?3:'',
      //       orderNo: this.orderNo,
      //     }
      //   })
      // }
    }
  },
};
</script>

<style lang="less" scoped>
@import "../asset/css/submitRefund.less";
</style>